import { Card, Col, Form, Input, Pagination, Row, Space } from "antd";
import { useEffect, useState } from "react";
import FeatureToolbarComponent from "../sgvmap/widgets/feature/FeatureToolbarComponent";

const VicaEDARGestAyt = ({ results, mapView, table, mapLayer, sublayer, currentTabsResult, setCurrenTabsResult }) => {
    const [result, setResult] = useState(results[0]);
    const [current, setCurrent] = useState(1);

    const onChangePagination = (page) => {
        setCurrent(page);
        setResult(results[page - 1]);
        let copy = Object.assign({}, currentTabsResult);
        copy[mapLayer.name + ": " + sublayer.title] = results[page - 1];
        setCurrenTabsResult(copy);
    };

    return (
        <>
            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}
            <Row justify="end" style={{ paddingBottom: "10px", paddingTop: "5px" }}>
                <FeatureToolbarComponent mapView={mapView} table={table} mapLayer={mapLayer} sublayer={sublayer} feature={result.feature}></FeatureToolbarComponent>
            </Row>
            <div>
                <Content result={result}></Content>
            </div>

            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}

        </>
    )
};
export default VicaEDARGestAyt;

const Content = ({ result }) => {


    useEffect(() => {
    }, [])

    console.log("result", result)
    const formatNumber = (num) => {
        if (num == null || num === undefined || num === "") {
            return "-";
        }
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    return (
        <Card>
            <Form layout="horizontal">
                <Form.Item label="EDAR">
                    <Input value={result.feature.attributes.NOMBRE} />
                </Form.Item>
                <Form.Item label="Descripción">
                    <Input value={result.feature.attributes.DESCRIPCI} />
                </Form.Item>
                <Form.Item label="Fecha Entrada Servicio">
                    <Input value={result.feature.attributes.FECHA_ENTR} />
                </Form.Item>
                <Form.Item label="Destino Efluente">
                    <Input value={result.feature.attributes.DESTINO_EF} />
                </Form.Item>
                <Form.Item label="Núcleos servidos">
                    <Input value={result.feature.attributes.NUCLEOS_SE} />
                </Form.Item>
                <Form.Item label="Habitantes Equivalentes">
                    <Input value={formatNumber(result.feature.attributes.HAB_EQ_D)} />
                </Form.Item>
                <Form.Item label="Subvencionada (año)">
                    <Input value={result.feature.attributes.ANN_SUBVEN} />
                </Form.Item>
                <Form.Item label="Coordenadas">
                    <Space.Compact>
                        <Form.Item>
                            <Input value={formatNumber(Math.round(result.feature.attributes.X_))} />
                        </Form.Item>
                        <Form.Item>
                            <Input value={formatNumber(Math.round(result.feature.attributes.Y_))} />
                        </Form.Item>
                    </Space.Compact>
                </Form.Item>
            </Form>
        </Card>
    )
}